import { render, staticRenderFns } from "./SegmentedButtons.vue?vue&type=template&id=4a9f50a7&"
import script from "./SegmentedButtons.vue?vue&type=script&lang=js&"
export * from "./SegmentedButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports